module.exports = __webpack_public_path__ + "static/media/infectious.0b6cf0aa.mp3";